import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../auth/auth.service';


import { Router } from '@angular/router';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private toastService = inject(ToastService);
  private authService = inject(AuthService);
  private router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const apiMessage = error.error?.message || error.error?.mensagem;
        
        if (error.status === 401) {
          const isAuthEndpoint = req.url.includes('/api/auth/login') ||
                                 req.url.includes('/api/auth/register') ||
                                 req.url.includes('/auth/google');

          if (!isAuthEndpoint && this.authService.isAuthenticated()) {
            this.authService.logout();
            this.toastService.error('Sessão expirada. Faça login novamente.');
          }
        } else if (error.status === 402) {
          this.toastService.warning(
            apiMessage || 'Período de avaliação expirado. Seus dados estão preservados. Escolha um plano para continuar.'
          );
          this.router.navigate(['/planos']);
        } else if (error.status === 403) {
          this.toastService.error('Você não tem permissão para acessar este recurso.');
        } else {
          this.toastService.error(apiMessage || 'Ocorreu um erro na requisição.');
        }

        return throwError(() => error);
      })
    );
  }
}
